/**
 * auto loop fix for video
 */
(function () {
  let videoEl = document.getElementById('bgVideo')  
  if (videoEl) {
    videoEl.addEventListener('ended', function () {
      videoEl.load();
      videoEl.play()
    }, false)
  }
})()